/**
 * Search template.
 */
import Context from '@shared/components/utils/context/mainContext';
import Focus from '@shared/types/enums/focus';
import FocusUtils from '@shared/utils/focus';
import Image from '@components/atoms/images/descriptionImage';
import MainContainer from '../atoms/container/contentContainer';
import SearchContainer from '../atoms/container/searchContainer';
import SearchInput from '../sections/search/searchInput';
import SearchKeyboard from '../sections/search/searchKeyboard';
import SearchResults from '../sections/search/searchResults';
import useSearch from '../../../shared/components/utils/hooks/useSearch';
import useKeyboard from '@shared/components/utils/hooks/useKeyboard';
import { setFocus } from '@shared/store/slices/focus.slice';
import { store } from '@shared/store/store';
import { appSelector } from '@shared/store/slices/app.slice';
import { useAppSelector } from '@shared/store/hooks';

export default function SearchTemplate() {
  // Selectors
  const { status } = useAppSelector(appSelector);

  // Search hook
  const {
    asset,
    error,
    input,
    message,
    queries,
    rails,
    searching,
    selection,
    totalResults,
    clearAction,
    searchAction,
    setAsset,
    onChangeElement,
    onChangeInput,
    onDeleteInput,
    onMouseEnter,
    outOfBoundsAction,
  } = useSearch();

  // Components data
  const actions = {
    clearAction,
    searchAction,
    onChangeElement,
    onChangeInput,
    onDeleteInput,
    outOfBoundsAction,
  };

  // Context
  const context = {
    asset,
    complete: rails.length > 0,
    hidePreviousItem: true,
    rails,
    onChangeElement,
    outOfBoundsAction,
    setAsset,
    setFilter: () => null,
  };

  // Keyboard hooks
  useKeyboard({
    canBeFocused: false,
    keyDownHandler: (key) => {
      const { focus: focusSlice } = store.getState();
      switch (key) {
        case 'BACK':
          if (FocusUtils.evaluateFocus(Focus.RAILS_LIST)) {
            store.dispatch(setFocus(Focus.SEARCH_KEYBOARD));
            return;
          }
          if (focusSlice.focus === Focus.QUERY_LIST) {
            store.dispatch(setFocus(Focus.SEARCH_KEYBOARD));
            return;
          }
          store.dispatch(setFocus(Focus.SEARCH));
          break;
        case 'RIGHT':
          if (
            focusSlice.focus === Focus.SEARCH ||
            focusSlice.focus === Focus.LOGIN
          ) {
            store.dispatch(setFocus(Focus.SEARCH_KEYBOARD));
          }
          break;
      }
    },
  });

  // Render
  return (
    <Context.Provider value={context}>
      {status.description && <Image src={asset?.photo || ''} />}
      <MainContainer>
        <SearchContainer onMouseEnter={onMouseEnter}>
          <SearchKeyboard actions={actions} queries={queries} />
          <SearchResults message={message} searching={searching} />
          <SearchInput
            input={input}
            error={error}
            results={totalResults}
            searching={searching}
            selection={selection}
          />
        </SearchContainer>
      </MainContainer>
    </Context.Provider>
  );
}
